/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2024 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2004 (c) Marc Fischer, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createAction, Dispatch } from '@reduxjs/toolkit';

const MsgListActionTypes = {
  Added: 'MsgList_Added',
  Delete: 'MsgList_Delete',
};

export type BootstrapColor_t = 'primary' | 'secondary' | 'success ' | 'danger' | 'warning ' | 'info';
export interface IMsgListElement {
  id: string;
  msg: string;
  severity: BootstrapColor_t;
}

export const MsgListAction = {
  Added: createAction<IMsgListElement>(MsgListActionTypes.Added),
  Delete: createAction<string>(MsgListActionTypes.Delete),
};

export default class MsgListActions {
  static Add(msg: string, severity: BootstrapColor_t = 'success ', timespanMs: number = 2000) {
    if (timespanMs <= 0) {
      throw 'Invalid Argument for timespanMs';
    }
    return (dispatch: Dispatch) => {
      const id = `${Date.now()}-${Math.floor(Math.random() * 10000)}`;
      dispatch(
        MsgListAction.Added({
          id: id,
          msg: msg,
          severity: severity,
        }),
      );
      setTimeout(() => {
        dispatch(MsgListAction.Delete(id));
      }, timespanMs);
    };
  }
}
